import './App.css';

import React, { useEffect, useState } from 'react';

import Avatar from '@mui/material/Avatar';
import Box from "@material-ui/core/Box";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons';
import { getUserId, registerUser, checkIsFavorite, toggleFavorite } from './favorites';

    

const NowPlaying = () => {
  const [nowplayingData, setNowPlaying] = useState([]);
  const [isFavorited, setIsFavorited] = useState(false);


  async function loadnowplaying() {
    var uuid = require("uuid");
    var id = uuid.v4();
    const response = await fetch(`https://megahit.live/assets/json/getnpassets.php?random=${id}`);
    var nowplaying = await response.json();
    setNowPlaying(nowplaying);
    
    await registerUser();
    const favorited = await checkIsFavorite(nowplaying.song_title, nowplaying.song_artist);
    setIsFavorited(favorited);
  }

  const handleFavoriteClick = async () => {
    if (!nowplayingData.song_title || !nowplayingData.song_artist) return;
    
    const newIsFavorited = await toggleFavorite(
      nowplayingData.song_title,
      nowplayingData.song_artist,
      nowplayingData.song_artwork,
      isFavorited
    );
    setIsFavorited(!isFavorited);
  }

  useEffect(() => {




      loadnowplaying();

  // the channel does not exist
  const socket = require("socket.io-client")("https://catalina.xseu.net", {
    path: "/3391/socket.io",
    rejectUnauthorized: false // WARN: please do not do this in production
  });

     
     // I expect this event to be triggered
     socket.on('FileChangedMEGAHIT', function(err){
      loadnowplaying();
         
     });


     window.addEventListener('focus', loadnowplaying);
 }, [])
  return (
   
  <div className="np-info">
     
      <div className="np-info-container">
          <div className="songinfo">
                  <FontAwesomeIcon 
                   icon={isFavorited ? faHeartSolid : faHeart} 
                   onClick={handleFavoriteClick}
                   style={{ 
                     fontSize: 28, 
                     color: isFavorited ? '#FF2C5E' : '#878fa4',
                     cursor: 'pointer',
                     marginRight: 10,
                     verticalAlign: 'middle',
marginTop: 20
                   }} 
                />
                 <Avatar 
        src={nowplayingData?.song_artwork?.replace("500x500", "50x50") || ""}
        alt={nowplayingData?.song_title}
        style={{ width: 50, height: 50, borderRadius: 10, marginTop: 10 }} />
              <div style={{display: 'flex', flexDirection: 'column', paddingLeft: 10, paddingTop: 15}}>
              <Box component={'span'} class="now-on-air-artist">{nowplayingData.song_artist}</Box>
             <Box component={'span'} class="now-on-air-title">{nowplayingData.song_title}</Box>
       </div>
      </div>
    </div>

       
   
  </div>
);
}

export default NowPlaying;



